export default [
    {
        path: '/purchases',
        name: 'Company / Purchase Orders',
        component: () => import('@/views/pages/purchases'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Overview Purchase',
                component: () => import('@/views/pages/purchases'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Purchase',
                component: () => import('@/views/pages/purchases'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];